/**
 * Renders the shopper's saved products on the Sanchay page
 * (templates/page.sanchay.json -> sections/main-wishlist.liquid).
 *
 * The wishlist itself only stores product HANDLES client-side (see
 * assets/wishlist.js), so this fetches each saved product's public
 * JSON via Shopify's storefront `/products/{handle}.js` endpoint and
 * builds a lightweight card -- there is nothing to render server-side
 * since Liquid never sees localStorage.
 */
(function () {
  function formatPrice(cents) {
    try {
      return (cents / 100).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      });
    } catch (error) {
      return '₹' + Math.round(cents / 100);
    }
  }

  function buildCard(product) {
    var li = document.createElement('li');
    li.className = 'wishlist-grid__item';

    var image = product.featured_image || (product.images && product.images[0]) || null;

    li.innerHTML =
      '<div class="wishlist-card">' +
      '<a href="' + product.url + '" class="wishlist-card__media-link">' +
      (image
        ? '<img class="wishlist-card__image" src="' + image + '&width=533" alt="' +
          (product.featured_image_alt || product.title).replace(/"/g, '&quot;') +
          '" loading="lazy" width="533" height="533">'
        : '') +
      '</a>' +
      '<div class="wishlist-card__content">' +
      '<a href="' + product.url + '" class="wishlist-card__title">' + product.title + '</a>' +
      '<span class="wishlist-card__price">' + formatPrice(product.price) + '</span>' +
      '</div>' +
      '<wishlist-button class="wishlist-card__remove" data-product-handle="' + product.handle + '">' +
      '<button type="button" class="wishlist-button__toggle" aria-pressed="true" aria-label="Remove from Sanchay">' +
      '<span class="wishlist-button__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 20.5s-7.5-4.6-10-9.2C0.4 8.1 1.8 4.5 5.2 3.5c2.1-0.6 4.3 0.3 5.6 2.1l1.2 1.6 1.2-1.6c1.3-1.8 3.5-2.7 5.6-2.1 3.4 1 4.8 4.6 3.2 7.8-2.5 4.6-10 9.2-10 9.2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>' +
      '</button>' +
      '</wishlist-button>' +
      '</div>';

    return li;
  }

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.emptyState = this.querySelector('[data-wishlist-empty]');
      this.loadingState = this.querySelector('[data-wishlist-loading]');
      this.load();
      window.addEventListener('wishlist:change', this.load.bind(this));
    }

    async load() {
      var Wishlist = window.Anjanikaa && window.Anjanikaa.Wishlist;
      if (!Wishlist || !this.grid) return;
      var handles = Wishlist.getAll();

      if (handles.length === 0) {
        this.grid.innerHTML = '';
        this.grid.hidden = true;
        if (this.emptyState) this.emptyState.hidden = false;
        if (this.loadingState) this.loadingState.hidden = true;
        return;
      }

      if (this.emptyState) this.emptyState.hidden = true;
      if (this.loadingState) this.loadingState.hidden = false;

      var results = await Promise.all(
        handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (response) {
              return response.ok ? response.json() : null;
            })
            .catch(function () {
              return null;
            });
        })
      );

      this.grid.innerHTML = '';
      var rendered = 0;
      results.forEach(function (product) {
        if (!product) return;
        this.grid.appendChild(buildCard(product));
        rendered += 1;
      }, this);

      if (this.loadingState) this.loadingState.hidden = true;

      if (rendered === 0) {
        this.grid.hidden = true;
        if (this.emptyState) this.emptyState.hidden = false;
      } else {
        this.grid.hidden = false;
      }
    }
  }

  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }
})();
